import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { Companyid, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddTenantZone extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        CompanyId: this.props.loggedUserDetail?.CompanyId || Companyid,
        tenantZoneId: '',
        zoneCode: '',
        zoneDescription: '',
        billingDate: '',
        dayOfMonth: '',
        dueDate: '',
        lateFee: '',
        graceDays: '',
        basicType: '',
        basisAmount: '',
        isEveryLateDays: false,
        isNotPaidbyDayofMonth: false,
        // taxId: '',
        touch: false,

    }

    // componentDidMount() {
    //     this.getAccess = HASACCESS(USER_SUBMENU_ID);
    //     let id = this.props.match.params.id;
    //     this.props.getMasterTableList('GeUsers?id=' + id);
    //     this.props.getMasterKeywordList('Role');
    //     this.props.getMasterKeywordList('Employee');
    //     this.props.getMasterKeywordList('ApprovalRole');
    //     let type = this.props.match.params.type;

    //     axios.get('/master/api/DropDownValues/FRole')
    //         .then(response => {
    //             if (response.status === 200) {
    //                 let data = []
    //                 if (response.data && response.data.length > 0) {
    //                     data = response.data.map(list => {
    //                         let value = list.id;
    //                         let id = list.id;
    //                         let text = list.text
    //                         return { label: text, value: value.toString(), id: id };
    //                     })
    //                 }
    //                 this.setState({ functionalRoleOptions: data })
    //             }
    //         }
    //         )
    //         .catch(err => {
    //             this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
    //         })

    //     if (type !== 'add') {
    //         this.timer();
    //     }
    // }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        const type = this.props.match.params.type;
        const id = this.props.match.params.id;
        console.log("ID =", this.props.match.params.id);

        this.setState({ type: type });

        this.props.getMasterKeywordList("TENANTZONE_BASIS");

        if (type !== "add" && id) {
            this.props.getMasterTableList(
                `res/GetTenantZonebyid?tenantzoneId=${id}`, this.state.CompanyId

            );
            //                 this.props.getMasterTableList(
            //     `res/GetTenantZonebyid?tenantzoneId=${id}&companyid=${Companyid}`
            // );

            // );
        }
    }

    // timer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //     }, 2000)
    // }
    // componentWillUnmount() {
    //     if (this.props.tableLists.usersList !== undefined) {
    //         clearInterval(this.intervalID);
    //     }
    // }

    // fetchSingleProcess = () => {

    //     let id = this.props.match.params.id;
    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists.usersList !== undefined) {
    //         storageItems = this.props.tableLists.users;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             let roles = '';
    //             let functionalRoles = '';
    //             let approvalroles = '';
    //             if (filterData.roleAssigned != null) {
    //                 roles = filterData.roleAssigned.split(",")
    //             }
    //             if (filterData.functionalRole != null) {
    //                 functionalRoles = filterData.functionalRole.split(",")
    //             }
    //             if (filterData.approvalrole != null) {
    //                 approvalroles = filterData.approvalrole.split(",")
    //             }
    //             var data = {
    //                 type: type,
    //                 Id: filterData.id,
    //                 UserId: filterData.userId,
    //                 EmployeeId: filterData.employeeId,
    //                 RoleId: roles,
    //                 approvalRoleId: approvalroles,
    //                 UserId1: filterData.userid1,
    //                 FirstName: filterData.firstName,
    //                 functionalRoleId: functionalRoles,
    //                 MiddleName: filterData.middleName,
    //                 LastName: filterData.lastName,
    //                 EmailId: filterData.emailId,
    //                 Password: filterData.password,
    //                 MobileNumber: filterData.mobileNumber,
    //                 Activedirectory: filterData.activedirectory,
    //                 Adloginid: filterData.adloginid,
    //                 Disablelogin: filterData.disablelogin,
    //                 IsActive: filterData.isActive,
    //                 CreatedBy: filterData.createdby,
    //                 CreatedDate: filterData.createddate,
    //             }
    //             this.setState(data);

    //         }
    //     }

    // }



    componentDidUpdate(prevProps) {

        if (this.props.tableLists !== prevProps.tableLists) {
            console.log("tableLists =", this.props.tableLists);

            const tenantZone = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!tenantZone) return;

            this.setState({
                CompanyId: tenantZone.Companyid,
                tenantZoneId: tenantZone.tenantZoneId || tenantZone.tenantzoneId || "",
                zoneCode: tenantZone.zoneCode || "",
                zoneDescription: tenantZone.zoneDescription || "",
                // billingDate: tenantZone.billingDate ? new Date(tenantZone.billingDate) : null,
                billingDate: tenantZone.billingDate ? new Date(2026, 0, tenantZone.billingDate) : null,
                dayOfMonth: tenantZone.dayOfMonth || "",
                // dueDate: tenantZone.dueDate || "",
                dueDate: tenantZone.dueDate ? new Date(2026, 0, tenantZone.dueDate) : null,
                lateFee: tenantZone.lateFee === true || tenantZone.lateFee === "true",
                graceDays: tenantZone.graceDays || "",
                basicType: tenantZone.basisType || "",
                basisAmount: tenantZone.basisAmount || "",
                isEveryLateDays: tenantZone.isEveryLateDays === true || tenantZone.isEveryLateDays === "true",
                isNotPaidbyDayofMonth: tenantZone.isNotPaidbyDayofMonth === true || tenantZone.isNotPaidbyDayofMonth === "true",
                // taxId: tenantZone.taxId || ""
            });
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (
    //         this.props.tableLists &&
    //         this.props.tableLists !== prevProps.tableLists
    //     ) {

    //         const data = this.props.tableLists;

    //         this.setState({
    //             tenantZoneId: data.tenantzoneId,
    //             zoneCode: data.zoneCode,
    //             zoneDescription: data.zoneDescription,
    //             billingDate: data.billingDate,
    //             dayOfMonth: data.dayOfMonth,
    //             dueDate: data.dueDate,
    //             lateFee: data.lateFee,
    //             graceDays: data.graceDays,
    //             basicType: data.basisType,
    //             basisAmount: data.basisAmount,
    //             isEveryLateDays: data.isEveryLateDays,
    //             isNotPaidbyDayofMonth: data.isNotPaidbyDayofMonth,
    //             taxId: data.taxId
    //         });
    //     }
    // }



    // change = (e) => {
    //     let { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true })

    // }
    // onDropdownChange = (e) => {
    //     const { name, value } = e.target;
    //     this.setState({ [name]: value, touch: true });
    // }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onDropdownChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    // handleChange = (e) => {

    //     const { name, value } = e.target;

    //     this.setState({ [name]: value });
    // }
    // handleChange = (e) => {
    //     this.setState({
    //         [e.target.name]: e.value,
    //         touch: true
    //     });
    // }
    handleChange = (e) => {
        const name = e.target.name;

        this.setState({
            [name]: e.value,
            touch: true
        });

        console.log(name, e.value);
    }
    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {
            companyid: this.state.CompanyId,
            zoneCode: this.state.zoneCode,
            zoneDescription: this.state.zoneDescription,

            billingDate: this.state.billingDate ? this.state.billingDate.getDate() : 0,

            // billingDate: this.state.billingDate,
            dayOfMonth: this.state.dayOfMonth,
            // dueDate: this.state.dueDate,
            dueDate: this.state.dueDate ? this.state.dueDate.getDate() : 0,

            lateFee: this.state.lateFee,
            graceDays: this.state.graceDays,
            basisType: this.state.basicType,
            basisAmount: this.state.basisAmount,
            isEveryLateDays: this.state.isEveryLateDays,
            isNotPaidbyDayofMonth: this.state.isNotPaidbyDayofMonth,
            // taxId: this.state.taxId,

        }


        if (this.state.type === 'edit') {

            data.tenantzoneId = this.state.tenantZoneId;   // based on your API

        }

        this.props.processDynamicData('tenantzone', this.state.type, data, 'res/GetTenantZonebyid?' + Companyid);
        console.log(data);
    }

    resetData = () => {
        var data = {
            // roles: [],
            type: 'add',
            Id: null,
            tenantZoneId: '',
            zoneCode: '',
            zoneDescription: '',
            billingDate: '',
            dayOfMonth: '',
            dueDate: '',
            lateFee: '',
            graceDays: '',
            basicType: '',
            basisAmount: '',
            isEveryLateDays: false,
            isNotPaidbyDayofMonth: false,
            // taxId: '',
            touch: false,
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/tenantzone/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/tenantzone/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }
        const { id, name, label, value, placeholder, fieldStatus, onInputChange, disabled, style } = this.props;


        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Tenant Zone</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Zone Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="zoneCode" placeholder="Zone Code" value={this.state.zoneCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Zone Description <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="zoneDescription" placeholder="Zone Description" value={this.state.zoneDescription} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="birthDate">Billing Date</label>
                                    <div className="mt1">
                                        <Calendar className="width100" placeholder="Enter Date" name='billingDate' value={this.state.billingDate} onChange={this.handleChange} dateFormat="dd/mm/yy"

                                            disabled={this.state.type === 'view'} />
                                    </div>
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Day <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="dayOfMonth" placeholder="Day" value={this.state.dayOfMonth} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Due / Pay by Date <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    {/* <InputText className="p-col-12" name="dueDate" placeholder="Due / Pay by Date" value={this.state.dueDate} onChange={this.change} disabled={this.state.type === 'view'} /> */}
                                    <Calendar className="width100" placeholder="Due / Pay by Date" name="dueDate" value={this.state.dueDate} onChange={this.handleChange} dateFormat="dd/mm/yy"

                                        disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12" style={style ? style : { marginTop: '38px' }}>
                                    <Checkbox
                                        inputId="lateFee"
                                        checked={Boolean(this.state.lateFee)}
                                        onChange={(e) =>
                                            this.setState({
                                                lateFee: e.checked,
                                                touch: true
                                            })
                                        }
                                        disabled={this.state.type === 'view'}
                                    />
                                    <label htmlFor="applyLateFee" className="p-checkbox-label">Apply Late fee</label>
                                </div>

                                <h4>Late Fee Charges</h4>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Grace Days <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="graceDays" placeholder="Grace Days" value={this.state.graceDays} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Basis <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Basis" options={this.props.TENANTZONE_BASIS} value={String(this.state.basicType)} name="basicType" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div>


                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Amount <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="basisAmount" placeholder="Amount" value={this.state.basisAmount} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-grid" style={{ marginTop: '0.5em' }}>
                                    <div className="p-col-12 p-md-6">
                                        {/* <RadioButton
                                            value="everyLateDays"
                                            name="lateFeeType"  // Same name for both
                                            onChange={event => this.setState({ lateFeeType: 'everyLateDays', touch: true })}
                                            checked={this.state.lateFeeType === 'everyLateDays'}
                                        /> */}
                                        {/* <RadioButton
                                            value="isEveryLateDays"
                                            checked={this.state.isEveryLateDays === "Every Late Days"}
                                            onChange={(e) => this.setState({
                                                isEveryLateDays: e.value,
                                                touch: true
                                            })}
                                        /> */}
                                        <RadioButton
                                            inputId="everyLate"
                                            name="lateType"
                                            checked={this.state.isEveryLateDays}
                                            onChange={() =>
                                                this.setState({
                                                    isEveryLateDays: true,
                                                    isNotPaidbyDayofMonth: false,
                                                    touch: true
                                                })
                                            }
                                        />

                                        <label htmlFor="rb1" className="p-radiobutton-label">Every Late Days</label>
                                    </div>
                                </div>

                                <div className="p-grid" style={{ marginTop: '0.5em' }}>
                                    <div className="p-col-12 p-md-6">
                                        {/* <RadioButton
                                            value="notPaidByDay"
                                            name="lateFeeType"  // Same name for both
                                            onChange={event => this.setState({ lateFeeType: 'notPaidByDay', touch: true })}
                                            checked={this.state.lateFeeType === 'notPaidByDay'}
                                        /> */}
                                        {/* <RadioButton
                                            value="isNotPaidbyDayofMonth"
                                            checked={this.state.isNotPaidbyDayofMonth === "Not Paid by Day of Month"}
                                            onChange={(e) => this.setState({
                                                isNotPaidbyDayofMonth: e.value,
                                                touch: true
                                            })}
                                        /> */}

                                        <RadioButton
                                            inputId="notPaid"
                                            name="lateType"
                                            checked={this.state.isNotPaidbyDayofMonth}
                                            onChange={() =>
                                                this.setState({
                                                    isEveryLateDays: false,
                                                    isNotPaidbyDayofMonth: true,
                                                    touch: true
                                                })
                                            }
                                        />


                                        <label htmlFor="notpaid" className="p-radiobutton-label">If Not Paid by Day of Month</label>
                                    </div>
                                </div>

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Tax ID <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown className="p-col-12" placeholder="Select Tax ID" options={this.props.GetEmployeedropdown} value={this.state.taxId} name="taxId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={this.state.type === 'view'} />
                                </div> */}

                                {/* <div className="p-col-12">
                                    <label htmlFor="acSimple">Status :</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch checked={this.state.IsActive} onChange={this.change} name="IsActive" value={this.state.IsActive} />
                                </div> */}
                            </div>
                            <div className="p-col-12 p-lg-12">

                                {/* <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData} to={redirectURL} /> */}
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/tenantzone/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        TENANTZONE_BASIS: (state.keyword.TENANTZONE_BASIS !== undefined) ? state.keyword.TENANTZONE_BASIS : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTenantZone);